import { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { usePathname } from "@lib/i18n/navigation-app-router";
import React from "react";
import IconSvg from "../IconSvg";
import { useSearchParams } from "next/navigation";

const InputButton = forwardRef(function InputButton(
  {
    title = "",
    subtitle,
    disabled,
    className,
    onClick = () => {},
    variant = "white", // white or light-gray
    checked = false,
    minWidth,
    leftIconName,
    rightIconName,
    trackingName = "",
    size,
    withTracking = true,
  },
  ref,
) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  function sendTrackerData() {
    if (!withTracking) return;

    const query = searchParams.toString() ? `?${searchParams.toString()}` : "";
    const page = `${pathname}${query}`;

    ahoy("$click", {
      tracking_name: trackingName,
      input_button: title || leftIconName,
      page,
    });

    analytics.track("$click", {
      tracking_name: trackingName,
      input_button: title || leftIconName,
      page,
    });
  }

  function handleClick(event) {
    sendTrackerData();
    onClick(event);
  }

  return (
    <button
      ref={ref}
      className={classNames(
        "input-btn font-weight-medium btn hug-content",
        size && `btn-${size} hug-content`,
        variant === "white" && "input-btn-white",
        variant === "light-gray" && "input-btn-light-gray",
        checked && "checked",
        disabled && "disabled",
        !title && "square",
        className,
        subtitle && `with-subtitle${size ? `-${size}` : ""}`,
      )}
      style={{ minWidth }}
      disabled={disabled}
      onClick={handleClick}
    >
      <div className={classNames("btn-container", !title && "icon-only")}>
        {leftIconName && (
          <div className={classNames("icon-container", size)}>
            <IconSvg name={leftIconName} />
          </div>
        )}

        <span className="btn-children-container">{title}</span>

        {rightIconName && (
          <div className={classNames("icon-container", size)}>
            <IconSvg name={rightIconName} />
          </div>
        )}
      </div>
      {subtitle && <div className="input-btn-subtitle">{subtitle}</div>}
    </button>
  );
});

InputButton.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(["white", "light-gray"]),
  checked: PropTypes.bool,
  minWidth: PropTypes.string,
  withTracking: PropTypes.bool,
};

export default InputButton;
